module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Reporting \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('small', [_c('router-link', {
    staticClass: "btn btn-default btn-fill btn-sm",
    attrs: {
      "to": {
        name: 'reporting.daily'
      }
    }
  }, [_vm._v("Switch to daily")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                                Room\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-6 text-right"
  }, [_vm._v("\n                                Turnover\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rooms), function(room) {
    return _c('tr', [_c('td', [_vm._v("\n                                    " + _vm._s(room.title) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.turnovers[room.id]) ? [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.turnovers[room.id], 2))) + "\n                                    ")] : _vm._e()], 2)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                                    Type\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-6 text-right"
  }, [_vm._v("\n                                    Turnover\n                                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.types), function(type) {
    return _c('tr', [_c('td', [_vm._v("\n                                    " + _vm._s(type.title) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.turnoverTypes[type.id]) ? [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.turnoverTypes[type.id], 2))) + "\n                                    ")] : _vm._e()], 2)])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n                                    VAT\n                                ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.20, 2))) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))))])])])])])])])]], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bebc130","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reporting/Reporting.vue
// module id = 399
// module chunks = 1